"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var View = /*#__PURE__*/function () {
  function View() {
    (0, _classCallCheck2["default"])(this, View);
    this.state = {
      components: {},
      mounted: []
    };
  }

  (0, _createClass2["default"])(View, [{
    key: "mountComponents",
    value: function mountComponents() {
      console.log('View : mountComponents', this);
      var state = this.state;
      var components = Array.from(document.querySelectorAll('[data-component]'));
      components.forEach(function (element, componentIndex) {
        var componentClass = element.getAttribute('data-component');
        var componentMounted = element.getAttribute('data-mounted') || false;

        if (element.getAttribute('data-mounted') == 'false') {
          componentMounted = false;
        }

        if (!componentMounted && state.components[componentClass] && typeof state.components[componentClass] === 'function') {
          state.mounted.push({
            id: "".concat(componentIndex),
            element: element,
            mounted: true,
            instance: new state.components[componentClass](element)
          });
          element.setAttribute('data-mounted', true);
        }
      });
    }
  }, {
    key: "unmountComponents",
    value: function unmountComponents() {
      var _this = this;

      console.log('View : unmountComponents', this);
      var state = this.state;
      state.mounted.forEach(function (component, index) {
        var shouldUnmount = _this.componentShouldUnmount(component.element);

        if (shouldUnmount && component.instance && component.mounted === true && typeof component.instance.unmount === 'function') {
          component.element.setAttribute('data-mounted', false);
          component.instance.unmount();
          component.mounted = false;
        }
      });
    }
  }, {
    key: "componentShouldUnmount",
    value: function componentShouldUnmount(element) {
      return document.documentElement.contains(element);
    }
  }]);
  return View;
}();

exports["default"] = View;